<template>
    <div>

        <p class="mb-0 pt-3">
            File caricati
        </p>

        <v-list dense>
            <v-list-item v-for="(file,i) in files"
                         :key="i"
                         :href="url(i)"
                         target="_blank">
                <v-list-item-icon>
                    <v-icon>
                        {{ getIcon(file) }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ getFilename(file) }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

    </div>
</template>

<script>
import Action from '@/models/action'

import fileMixin from '@/mixins/file'

export default 
{
   name: 'ActionProviderFileUploadFileList',

   mixins: [ fileMixin ],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    action: {
        type: Action,
        required: true
    }
   },

   computed: 
   {
    files()
    {
        return this.action.meta.uploads
    }
   },

   methods:
   {
    url(i)
    {
        return this.action.componentMeta.urls[i]
    }
   },

   mounted()
   {

   }
}
</script>